import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'
export const Z_INDEX_DESKTOP_ARTICLE_BUTTON_GROUP = 10
export const StyledArticleActionButtonGroup = styled.div`
  z-index: ${Z_INDEX_DESKTOP_ARTICLE_BUTTON_GROUP};
  position: sticky;
  top: min(9rem, 100vh / 3);
  bottom: unset;
  left: unset;
  width: 40px;
  margin-left: -104px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;

  &[data-is-nav-sponsor='true'] {
    top: min(7rem, 100vh / 3);
  }

  .icon-disabled {
    opacity: 0.2;
  }

  .share-popup-line:first-child {
    display: none;
  }

  ${MediaQueries.mbDown} {
    display: none;
  }
`
